import { useState, useEffect } from "react";
import { Modal, Checkbox } from "antd";
import { withLocale } from "../../l10n";
import { EXTRA_COLUMNS_CONFIG } from '../../utils/renewalsExport';

const STORAGE_KEY = 'renewals_export_config';

const DEFAULT_CONFIG = {
  extraColumns: []
};

function ExportConfigModal({ open, onCancel, onConfirm, lang }) {

  const [extraColumns, setExtraColumns] = useState(DEFAULT_CONFIG.extraColumns);

  useEffect(() => {
    if (open) {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        // Cargamos la configuración guardada (si existe).
        if (saved) {
          const parsed = JSON.parse(saved);
          setExtraColumns(parsed.extraColumns ?? DEFAULT_CONFIG.extraColumns);
        } else {
          setExtraColumns(DEFAULT_CONFIG.extraColumns);
        }
      } catch {
        setExtraColumns(DEFAULT_CONFIG.extraColumns);
      }
    }
  }, [open]);

  const handleConfirm = () => {
    const config = { extraColumns };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    onConfirm(config);
  };

  const columnOptions = EXTRA_COLUMNS_CONFIG.map(col => ({
    label: lang.handle(col.label),
    value: col.key,
  }));

  return (
    <Modal
      title={lang.handle('Configurar exportación')}
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText={lang.handle('Descargar')}
      cancelText={lang.handle('Cerrar')}
      width={400}
    >
      <div style={{ marginBottom: 8 }}>
        <strong>{lang.handle('Columnas adicionales')}</strong>
      </div>
      <Checkbox.Group
        options={columnOptions}
        value={extraColumns}
        onChange={setExtraColumns}
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      />
    </Modal>
  );
}

export default withLocale(ExportConfigModal);
